angular
    .module('tradersyard')
    .factory('search-query-filter', [
        '$flex',
        function ($flex) {
            var knowing = ['suggest', 'post', 'user', 'webinar', 'group', 'event', 'forum'];
            var hash = $flex.$hash.get();

            var params = {
                filter: knowing.indexOf(hash) !== -1 ? hash : 'suggest',
            };

            var filter = {
                init: function () {
                    var hash = $flex.$hash.get();

                    filter.set(knowing.indexOf(hash) !== -1 ? hash : 'suggest');
                },
                is: function (name) {
                    return params.filter === name;
                },
                set: function (name) {
                    params.filter = name;

                    if (filter.on.change) filter.on.change(name);

                    // $flex.$hash.set(name);
                    if ($flex.$hash.get() !== name) $flex.$hash.set(name);
                },
                params: params,
                on: {
                    change: undefined,
                },
            };

            return filter;
        },
    ])
    .controller('search-query-ctrl', [
        '$scope',
        '$timeout',
        '$location',
        'graph-search-factory',
        'search-query-filter',
        '$flex',
        'graph-like-factory',
        '$rootScope',
        function ($scope, $timeout, $location, $factory, $filter, $flex, $like, $root) {
            angular.extend($scope, $flex.data);

            $scope.userParams = {
                'data-feed': null,
                'endorse-tag': null,
                'trading-style': null,
                country: null,
                state: null,
                city: null,
                gender: null,
            };

            $scope.cities = [];
            $scope.tradingStyles = [];
            $scope.endorseTags = [];

            $scope.autoCompleteCity = {
                minimumChars: 1,
                data: function (keyword) {
                    return $factory
                        .entry('geo-cities')
                        .search({
                            params: {
                                q: keyword,
                                country_id:
                                    $scope.userParams.country === null
                                        ? null
                                        : $scope.countries[$scope.userParams.country].id,
                            },
                        })
                        .then(function (response) {
                            return response.data.data.map(function (city) {
                                return city.name;
                            });
                        });
                },
            };

            $scope.autoCompleteTradingStyle = {
                minimumChars: 1,
                data: function (keyword) {
                    return $factory
                        .entry('trading-styles')
                        .search({
                            params: {
                                q: keyword,
                                country_id:
                                    $scope.userParams.country === null
                                        ? null
                                        : $scope.countries[$scope.userParams.country].id,
                            },
                        })
                        .then(function (response) {
                            return response.data.data.map(function (city) {
                                return city.name;
                            });
                        });
                },
            };

            $scope.autoCompleteEndorseTag = {
                minimumChars: 1,
                data: function (keyword) {
                    return $factory
                        .entry('endorse-tags')
                        .search({
                            params: {
                                q: keyword,
                                country_id:
                                    $scope.userParams.country === null
                                        ? null
                                        : $scope.countries[$scope.userParams.country].id,
                            },
                        })
                        .then(function (response) {
                            return response.data.data.map(function (city) {
                                return city.name;
                            });
                        });
                },
            };

            $scope.nodes = [];

            $scope.process = 0;

            $scope.empty = true;

            $scope.entry = 'suggest';

            $scope.q = $location.search().q;

            $scope.params = {
                q: $location.search().q,
                page: 0,
                limit: 10,
            };

            $scope.filter = $filter;

            $scope.$on('search-scroll-update', function (e, nodes) {
                for (var entry in nodes) {
                    $scope.nodes[entry] = $scope.nodes[entry].concat(nodes[entry]);
                }
            });

            $scope.$on('search-data-update', function (e, empty, nodes, q) {
                $scope.empty = empty;
                $scope.nodes = nodes;
                $scope.q = q;
            });

            $filter.on.change = function (hash) {
                $scope.nodes = [];
                $scope.empty = true;
                $flex.$scroll.renew('search');
                $timeout(function () {
                    var entry = hash === 'suggest' ? undefined : hash;
                    $root.$broadcast('search-change-entry', entry);
                });
            };

            $scope.$watch(
                function () {
                    return $scope.userParams['data-feed'];
                },
                function (val, $nval) {
                    console.log(val);
                    if (val !== $nval) {
                        $scope.reloadSearch();
                    }
                }
            );

            $scope.$watch(
                function () {
                    return $scope.userParams.gender;
                },
                function (val, $nval) {
                    if (val !== $nval) {
                        $scope.reloadSearch();
                    }
                }
            );

            $scope.$watch(
                function () {
                    return $scope.userParams.city;
                },
                function (val, $nval) {
                    if (val !== $nval) {
                        $scope.reloadSearch();
                    }
                }
            );

            $scope.$watch(
                function () {
                    return $scope.userParams['trading-style'];
                },
                function (val, $nval) {
                    console.log(val !== $nval);
                    if (val !== $nval) {
                        $scope.reloadSearch();
                    }
                }
            );

            $scope.$watch(
                function () {
                    return $scope.userParams['endorse-tag'];
                },
                function (val, $nval) {
                    if (val !== $nval) {
                        $scope.reloadSearch();
                    }
                }
            );

            $scope.$watch(
                function () {
                    return $scope.userParams.country;
                },
                function (val, $nval) {
                    if (val !== $nval) {
                        $scope.reloadSearch();
                    }
                }
            );

            $scope.reloadSearch = function () {
                var country =
                    $scope.userParams.country === null ? null : $scope.countries[$scope.userParams.country].name;
                var userParams = angular.extend(angular.copy($scope.userParams), { country: country });
                $root.$broadcast('search.reload', userParams);
            };

            $scope.$on('search-q-change', function (e, q) {
                $scope.q = q;
                $scope.empty = true;
                $scope.nodes = [];
                $flex.$scroll.renew('search');
            });

            $scope.search = function (next) {
                $root.$broadcast('search-query-scroll', next);
            };

            $scope.$on('$historyBack', $filter.init);
        },
    ]);
